import { useMutation } from '@tanstack/react-query';
import { postUserActivityTracking } from '../../../../api/user/mutations/postUserActivityTracking';

export const usePostUserActivityTracking = () => {
  return useMutation(postUserActivityTracking);
};
